import { utcToZonedTime } from "date-fns-tz";
import { SCHEDULE_TYPE_MAP, SCHEDULE_TYPE_LIST } from "../../constants/sports";

export const toZonedTime = ({ stt, end }, zone) => {
    const currentDateTime = utcToZonedTime(new Date(), zone);
    const startDateTime = utcToZonedTime(new Date(stt), zone);
    const endDateTime = utcToZonedTime(new Date(end), zone);
    return { currentDateTime, startDateTime, endDateTime };
};

export const startNow = (zone) => (obj) => {
    const { currentDateTime, startDateTime, endDateTime } = toZonedTime(
        obj,
        zone
    );
    if (currentDateTime < startDateTime) {
        return true;
    }
    if (currentDateTime >= startDateTime && currentDateTime <= endDateTime) {
        return true;
    }
    return false;
};

export const createFormattedTypeList = (types) => {
    return Object.keys(
        createTypeGroupList(types).reduce((map, type) => {
            if (type && SCHEDULE_TYPE_MAP[type]) {
                map[SCHEDULE_TYPE_MAP[type]] = true;
            }
            return map;
        }, {})
    );
};

export const createTypeGroupList = (group) => {
    if (Array.isArray(group)) {
        return group.reduce((acc, type) => {
            if (type && type.startsWith("--")) {
                return acc.concat(createTypeGroupList(type));
            }
            if (SCHEDULE_TYPE_MAP[type]) {
                return acc.concat(type);
            }
            return acc;
        }, []);
    }
    const begin = SCHEDULE_TYPE_LIST.indexOf(group) + 1;
    if (begin !== 0) {
        const list = SCHEDULE_TYPE_LIST.slice(begin);
        const regex = /^--/;
        const end = list.findIndex((it) => regex.test(it));
        return end === -1 ? list : list.slice(0, end);
    }
    return [];
};

export const createDropDownList = (types) => {
    return createFormattedTypeList(types).map((sport) => ({ mainKey: sport }));
};
